import QuoteFragment from './QuoteFragment';
export default `
	query GetQuote($id: ID!) {
		getQuote(id: $id) {
			...QuoteFragment
		}
	}
	${QuoteFragment}
`;
